import { SEND_PAYMENT_LINK } from '../../constants/actions/payment';

export function sendPaymentLink() {
    return {
        type: SEND_PAYMENT_LINK,
    };
}
